/**
 * Created by Kotkin on 17.11.2017.
 */

import module from './comment-rules';

export default module;
